// ROAS is incremental outcome / spend; CPA is spend / incremental outcome.
// A zero denominator yields 0 rather than Infinity/NaN, which would distort the color bins.
export const getGeoResponse = (
  incrementalOutcome: number,
  spend: number,
  isCpa: boolean
): number => {
  const [numerator, denominator] = isCpa
    ? [spend, incrementalOutcome]
    : [incrementalOutcome, spend];
  return denominator ? numerator / denominator : 0;
};

// Best first: highest ROAS, or lowest CPA.
export const sortGeoEntriesByResponse = <T extends { response: number }>(
  entries: T[],
  insightsType: string
): T[] =>
  [...entries].sort((a, b) =>
    insightsType === 'bestandworstroas' ? b.response - a.response : a.response - b.response
  );
